import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-locked-icon',
  templateUrl: './communication-mail-locked.component.html'
})
export class CommunicationMailLockedComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
